import { Factory, association, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  flow: association(),

  actions: ['deny_entry'],
  metadata() {
    return { purpose: faker.lorem.words };
  },
  ignore: false,

  // traits
  withOneContact: trait({
    actions: ['alert'],
    afterCreate(signInFieldActionRuleGroup, server) {
      const employee = server.create('employee');
      server.create('sign-in-field-actions-contact', {
        signInFieldActionRuleGroup,
        employee,
        actionType: 'alert',
      });
    },
  }),
});
